import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadAuftragSBriefArchivListStatus: 'idle',
    loadAuftragSBriefArchivListError: undefined as any,
    loadAuftragSBriefArchivListLastArgs: undefined as any,
    loadAuftragSBriefArchivStatus: 'idle',
    loadAuftragSBriefArchivError: undefined as any,
    saveAuftragSBriefArchivStatus: 'idle',
    saveAuftragSBriefArchivError: undefined as any,
    deleteAuftragSBriefArchivStatus: 'idle',
    deleteAuftragSBriefArchivError: undefined as any,

    auftragSBriefArchivList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadAuftragSBriefArchivList = createAsyncThunk('auftragSBriefArchivSlice/loadAuftragSBriefArchivList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().auftragSBriefArchivSlice.loadAuftragSBriefArchivListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/ncremserienbrief/?action=gte&MIN_MODULTYPE=1&MAX_MODULTYPE=1&MIN_MODULOBJID=${parentModel.HDR_ID}&MAX_MODULOBJID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragSBriefArchivListStatus } = getState().auftragSBriefArchivSlice
        return loadAuftragSBriefArchivListStatus !== 'pending'
    }
})

export const loadAuftragSBriefArchiv = createAsyncThunk('auftragSBriefArchivSlice/loadAuftragSBriefArchiv', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/ncremserienbrief/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragSBriefArchivStatus } = getState().auftragSBriefArchivSlice
        return loadAuftragSBriefArchivStatus !== 'pending'
    }
})

export const saveAuftragSBriefArchiv = createAsyncThunk('auftragSBriefArchivSlice/saveAuftragSBriefArchiv', async ({ auftragSBriefArchiv }: any, { rejectWithValue }: any) => {
    let promises = []
    if (auftragSBriefArchiv?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/ncremserienbrief/${ auftragSBriefArchiv?.HDR_ID }/`,
            prepareData(auftragSBriefArchiv),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/ncremserienbrief/`,
            prepareData(auftragSBriefArchiv),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveAuftragSBriefArchivStatus } = getState().auftragSBriefArchivSlice
        return saveAuftragSBriefArchivStatus !== 'pending'
    }
})

export const deleteAuftragSBriefArchiv = createAsyncThunk('auftragSBriefArchivSlice/deleteAuftragSBriefArchiv', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/ncremserienbrief/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteAuftragSBriefArchivStatus } = getState().auftragSBriefArchivSlice
        return deleteAuftragSBriefArchivStatus !== 'pending'
    }
})

const AuftragSBriefArchivSlice = createSlice({
    name: 'auftragSBriefArchivSlice',
    initialState,
    reducers: {
        resetloadAuftragSBriefArchivListError: (state) => {
            state.loadAuftragSBriefArchivListError = undefined
        },
        resetloadAuftragSBriefArchiv: (state) => {
            state.formItem = undefined
            state.loadAuftragSBriefArchivError = undefined
        },
        resetloadAuftragSBriefArchivError: (state) => {
            state.loadAuftragSBriefArchivError = undefined
        },
        resetsaveAuftragSBriefArchiv: (state) => {
            state.formItem = undefined
            state.saveAuftragSBriefArchivError = undefined
        },
        resetsaveAuftragSBriefArchivError: (state) => {
            state.saveAuftragSBriefArchivError = undefined
        },
        resetdeleteAuftragSBriefArchivError: (state) => {
            state.deleteAuftragSBriefArchivError = undefined
        },
        removeFromAuftragSBriefArchivListById: (state, action) => {
            state.auftragSBriefArchivList = state.auftragSBriefArchivList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromAuftragSBriefArchivListByIds: (state, action) => {
            state.auftragSBriefArchivList = state.auftragSBriefArchivList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.auftragSBriefArchivList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadAuftragSBriefArchivListStatus = 'preloaded'
            state.loadAuftragSBriefArchivListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.auftragSBriefArchivList = []
            state.loadAuftragSBriefArchivListStatus = 'idle'
            state.loadAuftragSBriefArchivListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadAuftragSBriefArchivList.pending, (state) => {
            state.loadAuftragSBriefArchivListStatus = 'pending'
            state.loadAuftragSBriefArchivListError = undefined
        })
        builder.addCase(loadAuftragSBriefArchivList.fulfilled, (state, action) => {
            state.loadAuftragSBriefArchivListStatus = 'idle'

            if (!action.payload) { return }

            state.loadAuftragSBriefArchivListLastArgs = action.payload.args

            {
                state.auftragSBriefArchivList = action.payload.data

            }
        })
        builder.addCase(loadAuftragSBriefArchivList.rejected, (state, action) => {
            state.loadAuftragSBriefArchivListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragSBriefArchivListError = action.error.message
            } else {
                state.loadAuftragSBriefArchivListError = action.payload
            }
        })

        builder.addCase(loadAuftragSBriefArchiv.pending, (state) => {
            state.loadAuftragSBriefArchivStatus = 'pending'
            state.loadAuftragSBriefArchivError = undefined
        })
        builder.addCase(loadAuftragSBriefArchiv.fulfilled, (state, action) => {
            state.loadAuftragSBriefArchivStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragSBriefArchivList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragSBriefArchivList.push(newItem) }
                else { state.auftragSBriefArchivList[i] = { ...state.auftragSBriefArchivList[i], ...newItem } }
            }
        })
        builder.addCase(loadAuftragSBriefArchiv.rejected, (state, action) => {
            state.loadAuftragSBriefArchivStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragSBriefArchivError = action.error.message
            } else {
                state.loadAuftragSBriefArchivError = action.payload
            }
        })

        builder.addCase(saveAuftragSBriefArchiv.pending, (state) => {
            state.saveAuftragSBriefArchivStatus = 'pending'
            state.saveAuftragSBriefArchivError = undefined
        })
        builder.addCase(saveAuftragSBriefArchiv.fulfilled, (state, action) => {
            state.saveAuftragSBriefArchivStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragSBriefArchivList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragSBriefArchivList.push(newItem) }
                else { state.auftragSBriefArchivList[i] = { ...state.auftragSBriefArchivList[i], ...newItem } }
            }
        })
        builder.addCase(saveAuftragSBriefArchiv.rejected, (state, action) => {
            state.saveAuftragSBriefArchivStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveAuftragSBriefArchivError = action.error.message
            } else {
                state.saveAuftragSBriefArchivError = action.payload
            }
        })

        builder.addCase(deleteAuftragSBriefArchiv.pending, (state) => {
            state.deleteAuftragSBriefArchivStatus = 'pending'
            state.deleteAuftragSBriefArchivError = undefined
        })
        builder.addCase(deleteAuftragSBriefArchiv.fulfilled, (state, action) => {
            state.deleteAuftragSBriefArchivStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.auftragSBriefArchivList = state.auftragSBriefArchivList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.auftragSBriefArchivList = state.auftragSBriefArchivList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteAuftragSBriefArchiv.rejected, (state, action) => {
            state.deleteAuftragSBriefArchivStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteAuftragSBriefArchivError = action.error.message
            } else {
                state.deleteAuftragSBriefArchivError = action.payload
            }
        })

    }
})

export const {
    resetloadAuftragSBriefArchivListError,
    resetloadAuftragSBriefArchiv,
    resetloadAuftragSBriefArchivError,
    resetsaveAuftragSBriefArchiv,
    resetsaveAuftragSBriefArchivError,
    resetdeleteAuftragSBriefArchivError,
    removeFromAuftragSBriefArchivListById,
    removeFromAuftragSBriefArchivListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = AuftragSBriefArchivSlice.actions
export default AuftragSBriefArchivSlice.reducer
